export enum MarketsEnum {
    ENGLISH = "ENGLISH",
    GERMAN = "DEUTSCH",
    CHINESE = "中文"
}